// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-collection"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M18 12.5L19.587 14.8157L22.2797 15.6094L20.5678 17.8343L20.645 20.6406L18 19.7L15.3549 20.6406L15.4321 17.8343L13.7202 15.6094L16.4129 14.8157L18 12.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18 12.5L19.587 14.8157L22.2797 15.6094L20.5678 17.8343L20.645 20.6406L18 19.7L15.3549 20.6406L15.4321 17.8343L13.7202 15.6094L16.4129 14.8157L18 12.5Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-collection')
export default class MapCollectionIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-collection',
    }
  }
}
